import React, { useCallback, useEffect, useState } from 'react';

import { useDispatch } from 'src/store/useDispatch';
import { useSelector } from 'react-redux';

import PagePanel from 'src/components/PagePanel';
import { Table } from 'src/components/TableNew';
import PageHeader from 'src/components/PageHeader';
import NoResult from 'src/components/NoResult/NoResult';
import { useSearchQueryEffect } from 'src/hooks/useSearchQueryEffect';

import { fetchPresaleUsers, resetSearch, updateField, updateSearch } from 'src/store/slice/presaleUsers';

import { PRESALE_USERS_HEADERS } from 'src/utils/constants';

import PresaleUserDetailModal from './PresaleUserDetailModal';

const PresaleUsers = () => {
  const [currentPage, setCurrentPage] = useState(1);

  const dispatch = useDispatch();
  const {
    data: { presaleUsers, totalCount, totalPages, field, search },
    loading,
  } = useSelector(({ presaleUsers }) => presaleUsers);

  const runQuery = useCallback(
    (params: { page: number; field?: string; search: string }) => {
      dispatch(fetchPresaleUsers({ page: params.page, field: params.field, search: params.search }));
    },
    [dispatch],
  );

  useSearchQueryEffect({
    search,
    field,
    currentPage,
    setCurrentPage,
    query: runQuery,
  });

  useEffect(() => {
    return () => {
      dispatch(resetSearch());
    };
  }, [dispatch]);

  const items =
    presaleUsers?.map(({ user_id: { ...userRest }, ...rest }) => ({
      ...rest,
      ...userRest,
      name: userRest?.name?.first ? `${userRest.name.first} ${userRest.name.last}` : null,
      user_id: userRest.id,
      referral_reward: rest.referral_reward.token_allocation,
    })) ?? [];

  return (
    <PagePanel>
      <PageHeader
        title={`Pre-sale Users (${totalCount})`}
        dropdownTitle={PRESALE_USERS_HEADERS[0]}
        dropDownItems={['Referral Account', 'Receiving Wallet']}
        entity="presaleUsers"
        updateEntityField={updateField}
        updateEntitySearch={updateSearch}
      />
      {items.length > 0 || loading ? (
        <Table
          loading={loading}
          headers={PRESALE_USERS_HEADERS}
          items={items}
          columns="1fr 1fr 1fr 1.2fr 1fr 1fr 1fr"
          fieldsToShow={[
            'referral_reward',
            'total_allocation',
            'pending_allocation',
            'email',
            'kyc_status',
            'name',
            'created_at',
          ]}
          totalPages={totalPages}
          currentPage={currentPage}
          setCurrentPage={setCurrentPage}
          renderDetailsModal={(item, onClose) => (
            <PresaleUserDetailModal user={item} onClose={onClose} />
          )}
        />
      ) : (
        <NoResult />
      )}
    </PagePanel>
  );
};

export default PresaleUsers;
